import React from 'react'
import { Switch, Route, BrowserRouter, Redirect } from "react-router-dom";
import ChangePassword from './Pages/ChangePassword';
import ForgotPassword from './Pages/ForgotPassword';
import Login from './Pages/Login';
import Metabase from './Pages/Metabase'
import UsersManagement from './Pages/UsersManagement';

const App = () => {
  return (
    <>
    <BrowserRouter>
      <Switch>
        <Route exact path="/" ><Redirect to="/login" /> </Route>
        <Route exact path="/login" render={() => <Login />} />
        <Route exact path="/changepassword" render={() => <ChangePassword />} />
        <Route exact path="/forgotpassword" render={() => <ForgotPassword />} />
        <Route exact path="/users" render={() => <UsersManagement />} />
        <Route exact path="/metabase" render={() => <Metabase />} />
      </Switch>
    </BrowserRouter>
    </>
  )
}

export default App